import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { closeModal, openModal } from "redux/actions/global";
import DenounceImages from "components/Search/Article/ArticleImages/Denounceimages";

class DenounceImagesModal extends Component {
  constructor(props) {
    super(props);

    const { images, articleId } = props;

    this.state = {
      images,
      articleId,
    };
  }

  componentDidUpdate() {
    // this.setState({
    //   size: 5,
    //   from: 0,
    //   articleId: this.props.articleId
    // }, this.fetch);
  }

  render() {
    const { closeModal } = this.props;
    const articleImages = this.state.images;
    const articleId = this.state.articleId;

    return (
      <div className="panel denounceImages images">
        <div className="container">
          <div className="info-ctn">
            <div className="imagesTitle">Denuncia de imagenes</div>
            <div className="imagesSubtitle">Indica cuáles imágenes estarían infringiendo tus derechos</div>
            <i className="modal-close" onClick={closeModal} />
          </div>

          <DenounceImages
            // alt={this.state.data.articleTitle}
            images={articleImages}
            openModal={openModal}
            modal={true}
            articleId={articleId}
            // thumbnail={article.thumbnail}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.global.profile,
});

const actions = {
  closeModal,
};

export default withRouter(connect(mapStateToProps, actions)(DenounceImagesModal));
